module.exports = __webpack_public_path__ + "static/media/harts_truck_end.d82cdd72.png";